module.exports = __webpack_public_path__ + "static/img/MAG6.efcd2766.jpg";